import { render, staticRenderFns } from "./CoreGroupbuyingDetail.vue?vue&type=template&id=73d708c3&"
import script from "./CoreGroupbuyingDetail.vue?vue&type=script&lang=js&"
export * from "./CoreGroupbuyingDetail.vue?vue&type=script&lang=js&"
import style0 from "./CoreGroupbuyingDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports